import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import "../../styles/cards/card.css";
import Modal from "../modal/Modal";
import PrimaryButton from "../buttons/PrimaryButton";
import "../../styles/modal/modal.css";
import { AiOutlineLoading3Quarters } from "react-icons/ai";
import axios from "axios";
import Cookies from "js-cookie";
import confirmIcon from "../../assets/img/iconamoon--shield-yes-fill.svg";

const AddNewSiteCard = ({ onSiteAdded }) => {
  const [showModal, setShowModal] = useState(false);
  const [provinces, setProvinces] = useState([]);
  const [sites, setSites] = useState([]);
  const [selectedProvince, setSelectedProvince] = useState("");
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [sectors, setSectors] = useState([]);
  const [selectedSector, setSelectedSector] = useState("");
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [books, setBooks] = useState([]);
  const [bookCounts, setBookCounts] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const baseUrl = process.env.REACT_APP_BASE_URL;
  const role = Cookies.get("role");

  useEffect(() => {
    const fetchSites = async () => {
      try {
        const token = Cookies.get("token");
        const response = await axios.get(`${baseUrl}/api/sites/scanner-operator/all-sites`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        const sitesData = response.data;
        setSites(sitesData);

        const uniqueProvinces = [
          ...new Set(sitesData.map((site) => site.province)),
        ].sort();
        const uniqueDistricts = [
          ...new Set(sitesData.map((site) => site.district)),
        ].sort();
        const uniqueSectors = [
          ...new Set(
            sitesData
              .map((site) => site.sector)
              .filter((sector) => sector !== null)
          ),
        ].sort();

        setProvinces(uniqueProvinces);
        setDistricts(uniqueDistricts);
        setSectors(uniqueSectors);
      } catch (error) {
        console.error("Error fetching sites:", error);
        setError("Failed to load location data");
      }
    };
    fetchSites();
  }, [baseUrl, showModal, role]);

  const handleProvinceChange = (e) => {
    setSelectedProvince(e.target.value);
    setSelectedDistrict("");
    setSelectedSector("");
  };

  const handleDistrictChange = (e) => {
    setSelectedDistrict(e.target.value);
    setSelectedSector("");
  };

  const handleSectorChange = (e) => {
    setSelectedSector(e.target.value);
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedProvince("");
    setSelectedDistrict("");
    setSelectedSector("");
    setError(null);
  };
  const handleIconClick = () => {
    setShowModal(true);
  };

  const handleCloseConfirmationModal = () => {
    setShowConfirmationModal(false);
  };

  useEffect(() => {
    if (showConfirmationModal) {
      const timer = setTimeout(() => {
        setShowConfirmationModal(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [showConfirmationModal]);

  const handleSubmit = async () => {
    if (!selectedProvince || !selectedDistrict) {
      setError("Please select all location fields");
      return;
    }

    const payload = {
      province: selectedProvince,
      district: selectedDistrict,
      ...(selectedSector && { sector: selectedSector }),
    };

    setIsSubmitting(true);
    setError(null);

    try {
      const token = Cookies.get("token");
      const res = await axios.post(`${baseUrl}/api/sites/add`, payload, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status === 200) {
        setShowModal(false);
        setShowConfirmationModal(true);
        // Reset form
        setSelectedProvince("");
        setSelectedDistrict("");
        setSelectedSector("");
        onSiteAdded(res.data);
      }
    } catch (err) {
      if (err.response) {
        if (err.response.status === 409) {
          setError("This site has already been added");
        } else {
          setError(err.response.data.error || "Failed to add site");
        }
      } else {
        setError(err.message);
      }
    } finally {
      setIsSubmitting(false);
    }
  };
  return (
    <>
      <div className="new-site-container">
        <div className="icon-container">
          <Icon
            icon="fluent:add-24-filled"
            color="#000000"
            width="40"
            onClick={handleIconClick}
          />
        </div>
        <div className="description">Add New Site</div>

        <Modal show={showModal} onClose={handleCloseModal}>
          <div className="title">ADD A NEW SITE</div>
          <div className="content">
            <div className="form-container add-new-site">
              <form action="">
                <div className="label">
                  <div>Province</div>
                  <select
                    name="province"
                    id="province"
                    value={selectedProvince}
                    onChange={handleProvinceChange}
                  >
                    <option value="" disabled>
                      Select Province
                    </option>
                    {provinces.map((province) => (
                      <option key={province} value={province}>
                        {province}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="label">
                  <div>District</div>
                  <select
                    name="district"
                    id="district"
                    value={selectedDistrict}
                    onChange={handleDistrictChange}
                    disabled={!selectedProvince}
                  >
                    <option value="" disabled>
                      Select District
                    </option>
                    {districts
                      .filter((district) =>
                        sites.some(
                          (site) =>
                            site.province === selectedProvince &&
                            site.district === district
                        )
                      )
                      .map((district) => (
                        <option key={district} value={district}>
                          {district}
                        </option>
                      ))}
                  </select>
                </div>
                <div className="label">
                  <div>Sector</div>
                  <select
                    name="sector"
                    id="sector"
                    value={selectedSector}
                    onChange={handleSectorChange}
                    disabled={!selectedDistrict}
                  >
                    <option value="" disabled>
                      Select Sector
                    </option>
                    {sectors
                      .filter((sector) =>
                        sites.some(
                          (site) =>
                            site.province === selectedProvince &&
                            site.district === selectedDistrict &&
                            site.sector === sector
                        )
                      )
                      .map((sector) => (
                        <option key={sector} value={sector}>
                          {sector}
                        </option>
                      ))}
                  </select>
                </div>

                {error && <div className="error-message">{error}</div>}
              </form>
            </div>
            <div className="button-group">
              <PrimaryButton
                text={
                  isSubmitting ? (
                    <AiOutlineLoading3Quarters className="loader" />
                  ) : (
                    "Add Site"
                  )
                }
                onClick={handleSubmit}
              />
              <PrimaryButton text="Cancel" onClick={handleCloseModal} />
            </div>
          </div>
        </Modal>

        <Modal
          show={showConfirmationModal}
          onClose={handleCloseConfirmationModal}
        >
          <div className="content confirmation">
            <div className="icon-container">
              <img
                src={confirmIcon}
                alt="confirm"
                width="57"
                height="57"
                style={{ color: "#007011" }}
              />
            </div>
            <div className="text">
              You have successfully created a new site!
            </div>
          </div>
        </Modal>
      </div>
    </>
  );
};

export default AddNewSiteCard;
